import { camelCaseToSnakeCase } from "legacy/helpers.es6"
import InquiryAcceptToContractModal from "legacy/inquiries/InquiryAcceptToContractModal"
import InquiryDeclineModal from "legacy/inquiries/InquiryDeclineModal"
import PropTypes from "prop-types"
import React from "react"

// Note: The following globals are loaded from external scripts and not imported:
// - $ (jQuery): Used for AJAX requests
// - Amplitude: Used for analytics tracking

class InquiryActionsButton extends React.Component {
  constructor(args) {
    super(args)
    this.state = {
      showCreateContractModal: false,
      showDeclineModal: false,
    }
    this.updateStatus = this.updateStatus.bind(this)
    this.handleAmplitude = this.handleAmplitude.bind(this)
    this.handleActionButtonPressedAmplitude =
      this.handleActionButtonPressedAmplitude.bind(this)
    this.renderOption = this.renderOption.bind(this)
    this.openModal = this.openModal.bind(this)
  }

  openModal(name) {
    const newState = {}
    newState[name] = true
    this.handleActionButtonPressedAmplitude(camelCaseToSnakeCase(name))
    this.setState(newState)
  }

  updateStatus(event, status, redirect) {
    event.preventDefault()
    this.handleActionButtonPressedAmplitude(status)
    $.post(`${this.props.updateStatusEndpoint}`, { status }, () => {
      if (redirect) {
        window.location.assign(redirect)
      } else {
        window.location.reload()
      }
    })
  }

  handleActionButtonPressedAmplitude(action) {
    this.handleAmplitude("inquiry_mgmt:actions_button_pressed", {
      inquiry_action_selected: action,
    })
  }

  handleAmplitude(eventName, props = {}) {
    const defaultProps = {
      marina_id: this.props.marina.mcom_id,
      marina_name: this.props.marina.name,
    }
    const eventProps = { ...defaultProps, ...props }
    Amplitude.trackEvent(eventName, eventProps)
  }

  renderOption(label, onClick, href = "#", target, rel) {
    return (
      <a
        className="bs-py-2"
        href={href}
        onClick={onClick}
        target={target}
        rel={rel}
      >
        {label}
      </a>
    )
  }

  render() {
    return (
      <div className="btn-group">
        <button
          className="btn btn-primary dropdown-toggle rounded-l-none"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          style={{ borderLeftColor: "white" }}
        >
          ...
        </button>
        <ul className="dropdown-menu dropdown-menu-right">
          {!this.props.inProgress && (
            <li>
              {this.renderOption("In Progress", (event) =>
                this.updateStatus(event, "in_progress")
              )}
            </li>
          )}
          {!this.props.isClaim && (
            <li>
              {this.renderOption("Create Contract", () =>
                this.openModal("showCreateContractModal")
              )}
              <InquiryAcceptToContractModal
                closeModal={() =>
                  this.setState({ showCreateContractModal: false })
                }
                showModal={this.state.showCreateContractModal}
                endpoint={this.props.acceptEndpoint}
                groups={this.props.groups}
                groupId={this.props.groupId}
              />
            </li>
          )}
          {!this.props.isClaim && this.props.reservationUrl && (
            <li>
              {this.renderOption(
                "Create Reservation",
                () =>
                  this.handleActionButtonPressedAmplitude("create_reservation"),
                this.props.reservationUrl,
                "_blank",
                "noreferrer"
              )}
            </li>
          )}
          {this.props.convertToLongTermWaitlistEnabled && (
            <li>
              {this.renderOption("Add to Long-term Waitlist", (event) =>
                this.updateStatus(
                  event,
                  "waitlisted",
                  `/manage/${this.props.marina.slug}/waitlists/long_term/entries`
                )
              )}
            </li>
          )}
          {!this.props.isClaim && <li className="divider" role="separator" />}
          <li>
            {this.renderOption("Mark as Complete", (event) =>
              this.updateStatus(event, "completed")
            )}
          </li>
          <li>
            {this.renderOption("Decline", () =>
              this.openModal("showDeclineModal")
            )}
            <InquiryDeclineModal
              closeModal={() => this.setState({ showDeclineModal: false })}
              showModal={this.state.showDeclineModal}
              endpoint={this.props.updateStatusEndpoint}
            />
          </li>
        </ul>
      </div>
    )
  }
}

InquiryActionsButton.propTypes = {
  updateStatusEndpoint: PropTypes.string.isRequired,
  acceptEndpoint: PropTypes.string.isRequired,
  marina: PropTypes.shape({
    mcom_id: PropTypes.string,
    name: PropTypes.string.isRequired,
    slug: PropTypes.string,
  }).isRequired,
  inProgress: PropTypes.bool,
  isClaim: PropTypes.bool,
  reservationUrl: PropTypes.string,
  convertToLongTermWaitlistEnabled: PropTypes.bool,
  groups: PropTypes.array.isRequired,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InquiryActionsButton
